import * as UserSelectors from "../User/User.selector";
import * as FleetSelectors from "../Fleet/Fleet.selector";
import * as AuthUtils from "../../lib/util/AuthUtils";
import * as GroupUtils from "../../lib/util/GroupUtils";
import * as GlobalActions from "../Global/Global.action";
import { actionCreator } from "../../lib/util/ReduxUtils";

export const setScopeGroup = actionCreator<any | null>(
	"[GROUPS] SET_SCOPE_GROUP",
	(action, dispatch, getState) => {
		if (typeof action.payload === "string") {
			// Group ID only - we'll have to work out the root group, if any
			const state = getState();
			const groups = FleetSelectors.selectCurrentScopeFleetGroups(state);
			const group = GroupUtils.findGroupById(
				groups.value,
				action.payload || "",
			);
			const rootGroup = GroupUtils.findRootGroup(group);
			action.payload = {
				group: action.payload,
				rootGroupId: rootGroup?.id || undefined,
			};
		}

		return action;
	},
);

export const changeScopeGroup = actionCreator<any | null>(
	"[GROUPS] CHANGE_SCOPE_GROUP",
	(action, dispatch, getState) => {
		let group = action.payload;
		const state = getState();
		const oldGroupId = UserSelectors.selectCurrentScopeGroupId(state);
		const hasRoot = AuthUtils.canAccessRoot();
		const fleetId = UserSelectors.selectCurrentScopeFleetId(state);
		const groups = FleetSelectors.selectCurrentScopeFleetGroups(state);
		const groupData = GroupUtils.findGroupById(
			groups.value,
			action.payload || "",
		);
		const rootGroup = GroupUtils.findRootGroup(groupData);

		if (!hasRoot && !group) {
			group = UserSelectors.selectLoggedInUser(state)?.group || null;
		}

		if (!fleetId) {
			throw new Error("Missing fleet ID");
		}

		if (oldGroupId !== group) {
			dispatch(
				GlobalActions.getFleetData({
					fleetId,
					group,
					oldFleetId: fleetId,
				}),
			);
		}

		action.payload = {
			group: action.payload,
			rootGroupId: rootGroup?.id || undefined,
		};
		return action;
	},
);
